var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M437 0H75A75 75 0 0 0 0 75v362a75 75 0 0 0 75 75h362a75 75 0 0 0 75-75V75a75 75 0 0 0-75-75zm45 437a45 45 0 0 1-45 45H75a45 45 0 0 1-45-45V75a45 45 0 0 1 45-45h362a45 45 0 0 1 45 45zm0 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M91 422h90V210H91zm30-182h30v152h-30zm210-30a89.8 89.8 0 0 0-30 5.1V210h-90v212h90V315a15 15 0 0 1 30 0v107h90V304.7c0-48.6-39.4-94.7-90-94.7zm60 182h-30v-77a45 45 0 0 0-90 0v77h-30V240h30v30l24-18a59.5 59.5 0 0 1 36-12c32 0 60 30.3 60 64.7zM91 180h90V90H91zm30-60h30v30h-30zm0 0"
})));

export default SvgLinkedin;